import type { LucideIcon } from 'lucide-react'

import {
    ChartLine,
    CreditCard,
    LayoutDashboard,
    Settings,
    Users,
    UsersRound
} from 'lucide-react'

export type NavItem = {
    label: string
    href: string
    icon: LucideIcon
    description: string
    keywords: string[]
}

export type NavGroup = {
    label: string
    items: NavItem[]
}

export const NAV_GROUPS: NavGroup[] = [
    {
        label: 'Bisnis',
        items: [
            { label: 'Ringkasan', href: '/', icon: LayoutDashboard, description: 'KPI, tren MRR, dan aktivitas terbaru', keywords: ['dashboard', 'beranda', 'overview', 'mrr'] },
            { label: 'Pelanggan', href: '/pelanggan', icon: Users, description: 'Daftar akun, paket, dan status', keywords: ['customer', 'akun', 'klien'] },
            { label: 'Langganan', href: '/langganan', icon: CreditCard, description: 'Paket, faktur, dan pembayaran', keywords: ['tagihan', 'faktur', 'invoice', 'billing', 'paket'] },
            { label: 'Analitik', href: '/analitik', icon: ChartLine, description: 'Retensi, funnel, dan kanal akuisisi', keywords: ['laporan', 'kohort', 'funnel', 'retensi'] }
        ]
    },
    {
        label: 'Workspace',
        items: [
            { label: 'Tim', href: '/tim', icon: UsersRound, description: 'Anggota, peran, dan undangan', keywords: ['anggota', 'akses', 'peran', 'team'] },
            { label: 'Pengaturan', href: '/pengaturan', icon: Settings, description: 'Profil, workspace, notifikasi, tampilan', keywords: ['setting', 'profil', 'tema', 'notifikasi'] }
        ]
    }
]

export const NAV_ITEMS: NavItem[] = NAV_GROUPS.flatMap((group) => group.items)

export const getNavItem = (pathname: string): NavItem | undefined => NAV_ITEMS.find((item) => item.href === pathname)
